<template>
  <div>
    <div style="padding: 0 20px 30px 20px;">
      <!-- 信息总览 -->
      <!-- <TaskStatus :progress="progress" :taskId="taskId" :progressStatus="taskInfo.status" :onlyIncludeStatic="onlyIncludeStatic"></TaskStatus> -->
      <TaskStatus :key="taskId" v-if="show" :progress="progress" :progressStatus="taskInfo.status" :taskInfo="taskInfo" :taskId="taskId" :onlyIncludeStatic="onlyIncludeStatic"></TaskStatus>
      <!-- ai 解读 -->
      <AIOutput :content="state.staticSkill" v-if="state.staticSkill" />

      <template v-if="progress > 30">
        <!-- 机器学习引擎 -->
        <MachineLearning v-if="isNotEmptyEngine(state.machinelearning)" id="machinelearning" :machinelearning="state.machinelearning" />
        <!-- 外链判定 -->
        <URLInfoList
          v-if="state?.skillURLs?.length"
          :title="$t('report.analyse.external_link.title')"
          :list="state.skillURLs"
          :columnData="externalLinkColumns"
        />
        <!-- 二维码判定  -->
        <URLInfoList
          v-if="state?.qrcodeURLs?.length"
          :title="$t('report.analyse.qrcode_link.title')"
          :list="state.qrcodeURLs"
          :columnData="qrcodeLinkColumns"
        />
        <!-- 提取链接判定 -->
        <URLInfoList
          v-if="state?.extractURLs?.length"
          :title="$t('report.analyse.extract_link.title')"
          :list="state.extractURLs"
          :columnData="extractLinkColumns"
        />
        <!-- 静态判定 -->
        <StaticSearchSkill
          v-if="isNotEmpty(state.staticsearchskill)"
          id="staticsearchskill"
          :category="state.category"
          :staticsearchskill="state.staticsearchskill"
        />
        <!-- attck 矩阵 -->
        <MitreAttck
          v-if="progress === 100"
          id="mitreattck"
          :behaviorfeature="state.behaviorfeature"
          :onlyIncludeStatic="onlyIncludeStatic"
          :mitre="mitre"
        />
        <!-- 行为特征 -->
        <BehaviorFeature
          v-if="isNotEmpty(state.behaviorfeature) && state.behaviorfeature.signatures && state.behaviorfeature.signatures.length && progress === 100"
          id="behaviorfeature"
          :behaviorfeature="state.behaviorfeature"
          :mitre="mitre"
        />
        <template v-if="!onlyIncludeStatic && progress === 100">
          <BehaviorScreenshot
            v-if="state.behaviorscreenshot && state.behaviorscreenshot.shots && state.behaviorscreenshot.shots.length"
            id="behaviorscreenshot"
            :behaviorscreenshot="state.behaviorscreenshot"
          />
          <!-- 网络行为 -->
          <NetworkBehavior
            v-if="state.networkCount"
            id="networkbehavior"
            :taskId="taskId"
            :networkCount="state.networkCount"
            type="overview"
          />
          <!-- 行为总览 -->
          <BehaviorSummary id="behaviorsummary" :taskid="taskId" :progressanalyse="state.progressanalyse" />
        </template>
        <NetworkBehavior
            v-if="state.networkCount && onlyIncludeStatic && state.taskInfo.file_type === 'tcpdump'"
            id="networkbehavior"
            :taskId="taskId"
            :networkCount="state.networkCount"
            type="overview"
          />
      </template>
    </div>
    <detail-footer/>
  </div>
</template>

<script>

import eventDesc from '@/assets/markdown/event_description.json'
import StaticSearchSkill from '../StaticSearchSkill'
import MachineLearning from '../MachineLearning'
import MitreAttck from '../MitreAttck'
import BehaviorFeature from '../BehaviorFeature'
import BehaviorScreenshot from '../BehaviorScreenshot'
import NetworkBehavior from '../NetworkBehavior'
import BehaviorSummary from '../BehaviorSummary'
import TaskStatus from '../taskStatus'
import AIOutput from '../AIOutput.vue'
import URLInfoList from '../URLInfoList.vue'

import { resetTransition } from '@/hooks/useDom'
import { IS_PRODUCT_HOST } from '@/utils'

export default {
  name: 'analyse',
  components: {
    StaticSearchSkill,
    MachineLearning,
    MitreAttck,
    BehaviorFeature,
    BehaviorScreenshot,
    NetworkBehavior,
    BehaviorSummary,
    TaskStatus,
    AIOutput,
    URLInfoList
  },
  props: {
    taskInfo: {
      type: Object
    },
    summary: {
      type: Object
    },
    onlyIncludeStatic: {
      type: Boolean
    },
    progress: {
      type: Number
    },
    taskid: {
      type: Number
    },
    state: {
      type: Object
    },
    showProgress: {
      type: Boolean
    },
    mitre: {
      type: Array
    }
  },
  methods: {
    isNotEmpty(obj) {
      return Object.keys(obj).length !== 0
    },
    isNotEmptyEngine(obj) {
      if (this.state.machinelearning instanceof Array) {
        return this.state.machinelearning.length > 0
      } else {
        return this.state.machinelearning && this.state.machinelearning.detect && this.state.machinelearning.detect.length > 0
      }
    }
  },
  mounted() {
    resetTransition()
  },
  data() {
    return {
      staticsearchskill: {},
      machinelearning: {},
      behaviorfeature: {},
      behaviorscreenshot: {},
      networkCount: {},
      progressanalyse: {},
      category: 'file',
      taskOS: '',
      events: eventDesc.category,
      show: this.showProgress,
      isProduct: IS_PRODUCT_HOST
    }
  },
  computed: {
    externalLinkColumns() {
      return [
        { prop: 'url', label: 'URL', align: 'left', col: 3 },
        { prop: 'qex_type', type: 'custom_hover_tooltip', label: this.$t('report.analyse.external_link.file_type'), align: 'left', col: 2 },
        { prop: 'threat_level', label: this.$t('report.analyse.static.engine_judgment.title'), align: 'center', width: '120' },
        { prop: 'source', label: this.$t('report.analyse.mitre_att.dialog.source'), align: 'left', width: '160' }
      ]
    },
    qrcodeLinkColumns() {
      return [
        { prop: 'qrcode_preview', type: 'qrcode_image', label: this.$t('report.analyse.qrcode_link.qrcode'), align: 'center', width: '88' },
        { prop: 'url', label: 'URL', align: 'left', col: 3 },
        { prop: 'qex_type', type: 'custom_hover_tooltip', label: this.$t('report.analyse.external_link.file_type'), align: 'left', width: '120' },
        { prop: 'threat_level', label: this.$t('report.analyse.static.engine_judgment.title'), align: 'center', width: '120' },
        { prop: 'source', label: this.$t('report.analyse.mitre_att.dialog.source'), align: 'left', width: '120' }
      ]
    },
    extractLinkColumns() {
      return [
        { prop: 'url', label: 'URL', align: 'left', col: 3 },
        { prop: 'qex_type', type: 'custom_hover_tooltip', label: this.$t('report.analyse.external_link.file_type'), align: 'left', col: 2 },
        { prop: 'threat_level', label: this.$t('report.analyse.static.engine_judgment.title'), align: 'center', width: '120' },
        { prop: 'source', label: this.$t('report.analyse.mitre_att.dialog.source'), align: 'left', width: '160' }
      ]
    },
    taskId() {
      return this.$route.params.taskId || this.taskid
    },
    progree_combined() {
      return {
        showProgress: this.showProgress,
        taskid: this.taskid
      }
    }
  },
  watch: {
    // showProgress(n, o) {
    //   const that = this
    //   if (!n) {
    //     setTimeout(() => {
    //       that.show = false
    //     }, 2000)
    //   } else {
    //     that.show = true
    //   }
    // },
    progree_combined(n, o) {
      const that = this
      if (!n.showProgress) {
        if (n.taskid !== o.taskid) {
          this.show = false
        } else {
          setTimeout(() => {
            that.show = false
          }, 2000)
        }
      } else {
        this.show = true
      }
    }
  }
}
</script>
